import { useContext } from "react";
import { useQuery } from "react-query";

import { UserContext } from "../../Contexts";
import { UserClientHintService } from "../../Services";
import { NestedList } from "../List";
import { RecruitmentTypes } from "../../Constants";

import "./HomeSidebar.css";
import HomeSidebarSkeleton from "./HomeSidebarSkeleton";

const HomeSidebar = () => {
    const { user } = useContext(UserContext);
    const { data: hints, isLoading, isError } = useQuery(["HomeSidebarData"], UserClientHintService.get);

    if (isLoading) {
        return <HomeSidebarSkeleton />
    }

    const renderHintsSection = () => {
        if (isError || !hints) {
            return (
                <div className="home-sidebar__section">
                    <h3 className="home-sidebar__heading">
                        Etapy udziału w projekcie:
                    </h3>
                    <div className="color-danger">
                        Wystąpił problem z pobraniem podpowiedzi
                    </div>
                </div>
            );
        }

        if (hints?.length) {
            return (
                <div className="home-sidebar__section">
                    <h3 className="home-sidebar__heading">
                        Etapy udziału w projekcie:
                    </h3>
                    <NestedList data={hints} />
                </div>
            );
        }

        return null;
    };

    const renderStatuteLink = () => {
        const statuteBaseUrl = process.env.REACT_APP_PROJECT_DOC_STORAGE;
        const safeUrl = statuteBaseUrl ? encodeURI(statuteBaseUrl) : "";

        const registerDate = user.registerDate;
        if (!registerDate) {
            return null;
        }

        const [day, month, year] = registerDate.split("-").map(Number);
        const dateFormatted = new Date(year, month - 1, day);
        const dateToCheck = new Date(2024, 11, 12);
        const statutePath = 
            user.recruitmentType === RecruitmentTypes.New.value
                ? "Regulamin_MP_dla_rekrutacji_od_19.02.2026.pdf"
                : (
                    user.recruitmentType === RecruitmentTypes.Special.value && dateFormatted > dateToCheck
                    ? "Regulamin_MP_dla_rekrutacji_od_12.12.2024.pdf"
                    : "REGULAMIN.pdf"
                )

        return (
            <a className="home-sidebar__link" target="_blank"
                rel="noopener noreferrer"
                href={`${safeUrl}${statutePath}`}>
                Regulamin uczestnictwa w projekcie
            </a>
        );
    };

    return (
        <div className="home-sidebar">
            <div className="home-sidebar__section">
                <h3 className="home-sidebar__heading home-sidebar__line">
                    Witamy w PANELU KLIENTA
                </h3>

                <p className="home-sidebar__register-date">
                    Data rejestracji: <span className="bold">{user.registerDate}</span>
                </p>

                <div className="home-sidebar__pdf home-sidebar__line">
                    {renderStatuteLink()}
                    <p>(plik PDF otwiera się w nowym oknie)</p>
                </div>
            </div>

            {renderHintsSection()}
        </div>
    );
};

export default HomeSidebar;
